import { conformsTo, isString } from '../../typing/guards';

export interface Command<T> {
  readonly id: string;
  readonly key: string;
  readonly path: string;
  readonly payload: T;
}

export function isCommandWithPayload<T>(isPayload: (v: unknown) => v is T): (value: unknown) => value is Command<T> {
  return conformsTo({
    id: isString,
    key: isString,
    path: isString,
    payload: isPayload,
  });
}

export type CommandOperation = 'patch' | 'execute';
